import { useContext } from "react";
import ThemeContext from "../context/ThemeContext";

/**
 * THEMES-01 · Acceso al tema activo.
 * @returns {{ themePreference: string, resolvedTheme: string, setTheme: (p: string) => void }}
 */
export default function useTheme() {
  return useContext(ThemeContext);
}
